import React, { useState, useEffect } from 'react'

import { Helmet } from 'react-helmet'

import './profile-page.css'
import { getUser, signout } from './firebase'
import { useHistory } from 'react-router-dom'

const ProfilePage = (props) => {
  const [name, setName] = useState('No name set');
  const [email, setEmail] = useState('No email set');
  const [mobile, setMobile] = useState('No mobile set');
  const [referralCode, setReferralCode] = useState('No code set');
  const [mobileEdit, setMobileEdit] = useState(false);
  const [admin, setAdmin] = useState(false);
  let history = useHistory();

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem('firebase:authUser:AIzaSyCCxX4y8SwTmRNIJca6ms0v-T7O_FCQm0w:[DEFAULT]'));
    if (user) {
      let userData = async () => {
        let data = await getUser(user?.email);
        setName(prev => data?.name || prev);
        setEmail(prev => user?.email || prev);
        setMobile(prev => data?.phoneNumber || prev);
        setReferralCode(prev => data?.referralCode || prev);
        setAdmin(prev => data?.admin || prev);
      }
      userData();
    }
    else {
      history.push('/account');
    }
  }, [])

  return (
    <div className="profile-page-container">
      <Helmet>
        <title>profilePage - DeliBuddy</title>
        <meta property="og:title" content="profilePage - DeliBuddy" />
      </Helmet>
      <div className="profile-page-container1">
        <svg viewBox="0 0 1024 1024" className="profile-page-icon" onClick={()=>{
          history.goBack();
        }}>
          <path d="M512 0c282.857 0 512 229.143 512 512 0 281.143-228 512-512 512-283.429 0-512-230.286-512-512 0-282.857 229.143-512 512-512zM865.714 772c53.143-73.143 85.143-162.857 85.143-260 0-241.714-197.143-438.857-438.857-438.857s-438.857 197.143-438.857 438.857c0 97.143 32 186.857 85.143 260 20.571-102.286 70.286-186.857 174.857-186.857 46.286 45.143 109.143 73.143 178.857 73.143s132.571-28 178.857-73.143c104.571 0 154.286 84.571 174.857 186.857zM731.429 402.286c0-121.143-98.286-219.429-219.429-219.429s-219.429 98.286-219.429 219.429 98.286 219.429 219.429 219.429 219.429-98.286 219.429-219.429z"></path>
        </svg>
        <span className="profile-page-text">{name}</span>
        <span className="profile-page-text1">Email: - {email}</span>
        <span className="profile-page-text2" onClick={() => {
          if (!navigator.clipboard) {
            alert("Clipboard API not supported");
            return;
          }
          if (referralCode.includes('No code set')) {
            return;
          }
          navigator.clipboard.writeText(referralCode);
          alert("Referral code copied to clipboard");
        }}>Referral Code - {referralCode}</span>
        <div className="profile-page-container2">
          {!mobileEdit ?
            (<span className="profile-page-text3" onClick={() => {
              setMobileEdit(true)
              document.addEventListener('mousedown', (e) => {
                if (!e.target.closest('.profile-page-container2')) {
                  setMobileEdit(false)
                }
              })
            }}>{mobile}</span>) :
            (<input
              type="text"
              placeholder="Enter mobile number"
              className="profile-page-textinput input"
              value={mobile.includes('No mobile set') ? '' : mobile}
              onChange={(e) => {
                setMobile(e.target.value);
              }}
            />)}
          {mobileEdit && (<button className="profile-page-button button">Save</button>)}
        </div>
        <button className="profile-page-button1 button" onClick={()=>{
          signout();
          history.push('/account');
        }}>Log out</button>
      </div>
      <svg viewBox="0 0 1024 1024" className="profile-page-icon2" onClick={() => {
        history.goBack();
      }}>
        <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
      </svg>
    </div>
  )
}

export default ProfilePage
